export let Components = /*#__PURE__*/function (Components) {
  Components["FORM"] = "form";
  Components["NO_AVAILABILITY_FOR_DATE"] = "no availability for date empty state";
  Components["NO_AVAILABILITY_AT_ALL"] = "no availability at all empty state";
  Components["SLOT"] = "slot";
  Components["DATE"] = "date";
  Components["PAGINATION"] = "pagination";
  Components["SHOW_MORE"] = "show more";
  return Components;
}({});
export let Actions = /*#__PURE__*/function (Actions) {
  Actions["LOAD"] = "load";
  Actions["CLICK"] = "click";
  return Actions;
}({});
export let StaffPolicyComponents = /*#__PURE__*/function (StaffPolicyComponents) {
  StaffPolicyComponents["ASSIGN_RANDOMLY"] = "assign randomly";
  StaffPolicyComponents["ASSIGN_BY_PRIORITY"] = "assign by priority";
  return StaffPolicyComponents;
}({});
export let StaffPolicySubComponents = /*#__PURE__*/function (StaffPolicySubComponents) {
  StaffPolicySubComponents["HIGHEST"] = "highest";
  StaffPolicySubComponents["LOWEST"] = "lowest";
  StaffPolicySubComponents["SET_PRIORITY"] = "set priority";
  return StaffPolicySubComponents;
}({});
export const SCHEDULING_FIELD_PAGE_NAME = 'scheduling_field';
//# sourceMappingURL=bi-types.js.map